import React from "react";
import SEO from "@/components/SEO";
import PortalPreviewShell from "@/components/demo/PortalPreviewShell";

export default function PortalPreview() {
  return (
    <>
      <SEO
        title="Client Portal Preview — See LabComplyx Before You Sign In"
        description="Explore a live preview of the LabComplyx Client Portal with sample data: Workspace, Quality Overview traceability, Compliance Center AI Tools, and Implementation Tracker, with a guided Demo Navigator tour."
        canonical="https://labcomplyx.com/portal-preview"
      />
      <PortalPreviewShell />
    </>
  );
}
